module.exports = __webpack_public_path__ + "img/p9-p1-text.da35fc72.png";